// extracted by mini-css-extract-plugin
export default {"primaryMfaBlueButton":"_2bxIgkwv7HZB7_dqZWwsVL"};